'use client';

import { useEffect } from 'react';
import { initSessionActivityTracking } from '@/lib/auth/session-activity';

/**
 * Composant client qui initialise le suivi d'activité de session
 * Ce composant doit être inclus dans le layout principal de l'application
 */
export default function SessionActivityTracker() {
  useEffect(() => {
    // Initialiser le suivi d'activité de session au montage du composant
    try {
      initSessionActivityTracking();
      console.log('🔐 Suivi d\'activité de session initialisé');
    } catch (error) {
      console.error('Erreur lors de l\'initialisation du suivi d\'activité:', error);
    }
    
    // Pas besoin de nettoyer car le nettoyage est géré dans initSessionActivityTracking
  }, []);
  
  // Ce composant ne rend rien dans le DOM
  return null;
}
